import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useContext, useEffect, useMemo, useState } from "react";
import { useEmbarqueDependencias } from "../../contexts/EmbarqueDependenciasContext.tsx";
import RequestControllerRedux from "../../contexts/RequestController.js";
import TabelaRedux from "../../contexts/Tabela";
import CustomButtonV2 from "../CustomButtonV2/CustomButtonV2.js";
import ModalCadastro from "../ModalCadastro/ModalCadastro.tsx";
import "../ModalLancarStatus/ModalLancarStatus.css";
import NewIcon from "../NewIcon/NewIcon";
import SelectEmbarqueV2 from "../SelectEmbarqueV2/SelectEmbarqueV2";

export interface SimpleDialogProps {
	titulo: string;
	tituloBotao: string;
	tituloConfirmar: string;
	texto: string;
	dataAlteracao: string;
	open: boolean;
	onClose: () => void;
	onClick: () => void;
	setStatus: (e) => void;
}

function ModalLancarStatus(props: SimpleDialogProps) {
	const { onClose, open, onClick } = props;

	const { status: listaStatus } = useEmbarqueDependencias();

	const { setDadosRequestControllerRedux } = useContext(RequestControllerRedux);

	const { tabelaRedux } = useContext(TabelaRedux);

	const [valuesSelect, setValuesSelect] = useState<any>([]);

	const handleClose = () => {
		onClose();
		if (statusSelecionado) {
			setValuesSelect((current) => ({
				...current,
				status: {
					value: statusSelecionado.nome,
					label: statusSelecionado.nome,
					id: statusSelecionado.idStatus,
				},
			}));
			props.setStatus(statusSelecionado.idStatus);
		}
	};

	const handleClick = () => {
		onClick();
	};

	const clearStatus = () => {
		setValuesSelect((current) => ({ ...current, status: "" }));
	};

	const [idAtual, setIdAtual] = useState(0);

	const [disable, setDisable] = useState(false);

	const [openCadastroStatus, setOpenCadastroStatus] = useState(false);

	const statusSelecionado = useMemo(() => {
		return listaStatus.find(
			(option) => option.nome === tabelaRedux?.row?.status
		);
	}, [listaStatus, tabelaRedux?.row?.status]);

	useEffect(() => {
		if (statusSelecionado) {
			setValuesSelect((current) => ({
				...current,
				status: {
					value: statusSelecionado.nome,
					label: statusSelecionado.nome,
					id: statusSelecionado.idStatus,
				},
			}));
			props.setStatus(statusSelecionado.idStatus);
		}
	}, [statusSelecionado]);

	const handleCloseCadastroStatus = () => {
		if (idAtual) {
			setOpenCadastroStatus(false);
			setDadosRequestControllerRedux("Close Status");
		} else {
			setDadosRequestControllerRedux("Close Status");
			setOpenCadastroStatus(false);
		}
	};

	return (
		<div>
			<Dialog open={open} onClose={handleClose}>
				<div className="div-modal-usuario">
					<DialogTitle id="alert-dialog-title">{props.titulo}</DialogTitle>
					<DialogContent className="content-veiculo">
						<div className="usuario-data-row">
							<div className="coluna-modalmotivo">
								<div>
									<p className="input-label-emb">Status:</p>
									<SelectEmbarqueV2
										classeCss={180}
										onChange={(e) => {
											setValuesSelect((current) => ({
												...current,
												status: e,
											}));
											props.setStatus(e.id);
										}}
										clearSelection={clearStatus}
										pequeno={true}
										id="idStatus"
										value={valuesSelect.status}
										titulo="Status"
										dadosSelect={listaStatus}
										referenciaId="nome"
										referenciaItem="nome"
										info={false}
									/>
								</div>
								<NewIcon
									onClick={(e) => {
										setOpenCadastroStatus(true);
										setIdAtual(0);
										setDisable(false);
									}}
								/>
							</div>
						</div>
					</DialogContent>
					<DialogActions>
						<CustomButtonV2
							classCss="custom-button-cadastrar"
							classText="button-texto-cadastrar"
							titulo="OK"
							cor="#0946B8"
							onClick={handleClick}
						/>
						<CustomButtonV2
							classCss="custom-button-cancelar"
							classText="button-texto-cancelar"
							titulo="Cancelar"
							cor="#0946B8"
							onClick={handleClose}
						/>
					</DialogActions>
				</div>
			</Dialog>
			<div>
				<ModalCadastro
					titulo="Cadastro"
					tituloConfirmar="OK"
					cadastroStatus="sim"
					open={openCadastroStatus}
					idAtual={idAtual}
					desabilitar={disable}
					onClose={handleCloseCadastroStatus}
				/>
			</div>
		</div>
	);
}

export default ModalLancarStatus;
